import { render, staticRenderFns } from "./SpecialistGoals.vue?vue&type=template&id=e99d59da&scoped=true&"
import script from "./SpecialistGoals.vue?vue&type=script&lang=js&"
export * from "./SpecialistGoals.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistGoals.vue?vue&type=style&index=0&id=e99d59da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99d59da",
  null
  
)

export default component.exports